/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookedExamResponse } from './BookedExamResponse';
import {
    BookedExamResponseFromJSON,
    BookedExamResponseFromJSONTyped,
    BookedExamResponseToJSON,
    BookedExamResponseToJSONTyped,
} from './BookedExamResponse';

/**
 * 
 * @export
 * @interface StarterResponse
 */
export interface StarterResponse {
    /**
     * 
     * @type {number}
     * @memberof StarterResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof StarterResponse
     */
    showId?: number;
    /**
     * 
     * @type {number}
     * @memberof StarterResponse
     */
    startNo?: number;
    /**
     * 
     * @type {string}
     * @memberof StarterResponse
     */
    bookerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StarterResponse
     */
    horseRegisterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StarterResponse
     */
    riderRegisterId?: string | null;
    /**
     * 
     * @type {Array<BookedExamResponse>}
     * @memberof StarterResponse
     */
    bookedExams?: Array<BookedExamResponse> | null;
}

/**
 * Check if a given object implements the StarterResponse interface.
 */
export function instanceOfStarterResponse(value: object): value is StarterResponse {
    return true;
}

export function StarterResponseFromJSON(json: any): StarterResponse {
    return StarterResponseFromJSONTyped(json, false);
}

export function StarterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StarterResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'showId': json['showId'] == null ? undefined : json['showId'],
        'startNo': json['startNo'] == null ? undefined : json['startNo'],
        'bookerId': json['bookerId'] == null ? undefined : json['bookerId'],
        'horseRegisterId': json['horseRegisterId'] == null ? undefined : json['horseRegisterId'],
        'riderRegisterId': json['riderRegisterId'] == null ? undefined : json['riderRegisterId'],
        'bookedExams': json['bookedExams'] == null ? undefined : ((json['bookedExams'] as Array<any>).map(BookedExamResponseFromJSON)),
    };
}

export function StarterResponseToJSON(json: any): StarterResponse {
    return StarterResponseToJSONTyped(json, false);
}

export function StarterResponseToJSONTyped(value?: StarterResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'showId': value['showId'],
        'startNo': value['startNo'],
        'bookerId': value['bookerId'],
        'horseRegisterId': value['horseRegisterId'],
        'riderRegisterId': value['riderRegisterId'],
        'bookedExams': value['bookedExams'] == null ? undefined : ((value['bookedExams'] as Array<any>).map(BookedExamResponseToJSON)),
    };
}

